// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"8d573227","100":"76beeb08","134":"f102d8d0","187":"29241450","198":"9a9b6ec0","295":"96aeba48","481":"d8702b1a","488":"371f7511","601":"fa2e5f52","647":"e0d599a0","829":"7f503d37"}[chunkId] + ".chunk.js";
};